type ConstructStyledOptionsProps = {
  propsToNotForward: string[];
};

interface ConstructStyledOptionsInterface {
  shouldForwardProp: (prop: PropertyKey) => boolean;
}

const notForwardProps = (prop: PropertyKey, propsToNotForward: string[]): boolean => {
  return !propsToNotForward.includes(prop as string);
};

export const constructStyledOptions = ({
  propsToNotForward,
}: ConstructStyledOptionsProps): ConstructStyledOptionsInterface => {
  const optionsWithShouldForwardProps = {
    shouldForwardProp: (prop: PropertyKey) => notForwardProps(prop, propsToNotForward),
  };

  return optionsWithShouldForwardProps;
};
